import http from './http'

export function listStorage(params) {
  return http.get('/storage', { params })
}

export function getStorageUsage() {
  return http.get('/storage/usage')
}

export function deleteStorageFile(id) {
  return http.delete(`/storage/${id}`)
}

export function deleteAllStorage(params) {
  return http.delete('/storage/all', { params })
}
